<template>
  <div class="contractManagement-chooseAddress-dialog">
    <el-dialog v-drag-dialog :title="model.title" :visible.sync="visible" :before-close="closeDialog" :close-on-click-modal="false" :append-to-body="true" width="1000px">
      <div class="dialog-body" style="padding: 0 24px">
        <div class="search-hd">
          <el-form :inline="true" @submit.native.prevent>
            <el-form-item>
              <el-button type="primary" icon="el-icon-plus" @click="addAddress()">{{ $t('Common.com_added') }}</el-button>
            </el-form-item>
            <el-form-item style="float: right">
              <search-input v-model="formSearch.search" :placeholder="$t('crm_chooseAddressDialog.lxrshdz')" @fetch="onPageChange({ page: 1 })"></search-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="table-bd">
          <custom-table
            type="radio"
            ref="tb1"
            v-loading="isLoading"
            v-model="selectedRow"
            :data="addressList"
            :column="tableColumn"
            @filter="filterChange"
            @sort="sortChange"
            :slots="['detailAddress', 'action']"
          >
            <template slot="detailAddress" slot-scope="scope">{{ scope.row.country }}{{ scope.row.province }}{{ scope.row.city }}{{ scope.row.detailAddress }}</template>
            <template slot="action" slot-scope="scope">
              <span></span>
              <el-button type="text" size="mini" @click="deleteAddress(scope.row)">{{ $t('Common.com_delete') }}</el-button>
              <el-button v-if="scope.row.isDefault === true" type="text" size="mini" style="color: red !important">{{ $t('crm_chooseAddressDialog.mo_ren_di_zhi') }}</el-button>
              <el-button v-else type="text" size="mini" @click="defaultAddress(scope.row)">{{ $t('crm_chooseAddressDialog.she_wei_mo_ren') }}</el-button>
            </template>
          </custom-table>
        </div>
        <div class="table-page">
          <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">{{ $t('Common.com_cancel') }}</el-button>
        <el-button type="primary" @click="saveInsert">{{ $t('Common.com_confirm') }}</el-button>
      </div>
    </el-dialog>
    <financeAddressDialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false" @success="getAddressList"></financeAddressDialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';
import financeAddressDialog from '@/pages/crm/financeAddress/children/finance_address_dialog.vue';

export default {
  components: {
    financeAddressDialog,
  },
  mixins: [dialogMixins],
  data() {
    return {
      tableCode: 'contract_choose_address',
      addressList: [],
      totalRows: null,
      formSearch: {
        partnerOrgId: '',
        search: '',
        pageSize: 20,
        pageNum: 1,
      },
      selectedRow: undefined,
      dialogVisible: false,
      dialogModel: {},
    };
  },
  mounted() {
    this.initDialog();
    this.getAddressList();
    this.getTableColumn();
  },
  methods: {
    // 初始化
    initDialog: function () {
      this.$nextTick(() => {
        this.visible = true;
      });
      this.formSearch.partnerOrgId = this.model.data.partnerOrgId;
    },
    // 关闭弹窗
    closeDialog: function () {
      this.visible = false;
      setTimeout(() => {
        this.$emit('close', false);
      }, 250);
    },
    // 获取关联列表
    getAddressList: function () {
      this.$getJSON(apis.partnerDeliverAddressListByPartnerOrgId, this.formSearch).then((res) => {
        this.addressList = res.data.list;
        this.totalRows = res.data.total;
        const defaultItem = this.addressList.find((i) => i.isDefault);
        if (defaultItem) {
          this.selectedRow = defaultItem;
          this.$nextTick(() => {
            this.$refs.tb1.initTable();
          });
        }
      });
    },
    // 切换页
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getAddressList();
    },
    // 新增地址
    addAddress: function () {
      this.dialogModel.title = this.$t('crm_chooseAddressDialog.xzshdz');
      this.dialogModel.type = 'contract_add';
      this.dialogModel.data = {
        partnerOrgId: this.model.data.partnerOrgId,
      };
      this.dialogVisible = true;
    },
    // 删除地址
    deleteAddress: function ({ deliverAddressId }) {
      const tips = this.$t('crm_chooseAddressDialog.qrscxzddzm');
      this.$showConfirm(tips)
        .then(() => {
          this.$deleteJSON(`${apis.partnerDeliverAddressDelete}/${deliverAddressId}`).then(() => {
            this.$message({
              message: this.$t('Common.com_delete_success'),
              type: 'success',
            });
            this.getAddressList();
          });
        })
        .catch(() => {});
    },
    // 设为默认
    defaultAddress: function ({ deliverAddressId }) {
      this.$postJSON(`${apis.partnerDeliverAddressDefualt}/${deliverAddressId}`).then(() => {
        this.$message({
          message: this.$t('Common.com_handle_success'),
          type: 'success',
        });
        this.getAddressList();
      });
    },
    // 保存新增
    saveInsert: function () {
      // 验证
      if (this.selectedRow) {
        this.closeDialog();
        this.$emit('success', [this.selectedRow], this.model.data.type);
      } else {
        this.$message({
          message: this.$t('crm_chooseAddressDialog.qing_xuan_ze_di_zhi'),
          type: 'error',
        });
      }
    },
  },
};
</script>

<style lang="scss">
.contractManagement-chooseAddress-dialog {
  .title {
    line-height: 24px;
    font-size: 16px;
    padding-left: 10px;
    position: relative;
    color: #595959;
    margin-bottom: 24px;
    .tag {
      width: 4px;
      height: 15px;
      background-color: #00afff;
      left: 0;
    }
  }
}
</style>
